import { getSEOEndpoint as getSEOEndpointUtil } from '@nykaa/utils/urls';

export enum ROUTES {
  PRODUCT,
  AUTH,
  WISHLIST_IDS,
  RECO_WIDGETS,
  CHECK_DELIVERY,
  SEARCH_SUGGESTIONS,
  TRENDING_SEARCHES,
  GATEWAY,
  OFFERS,
  REVIEW_PHOTOS,
  LIKE_REVIEW,
  NAVIGATION,
  LOGOUT,
  QNA,
  NEWS_LETTER_SUBSCRIPTION,
  GET_VARIANTS,
  GRAPH_API,
  FB_API,
  GOOGLE_API,
  LOGIN,
  PRODUCT_LIST,
  DEVICE_TRACKING_SERVICE,
  CATEGORY_PRICE_LIST,
  FOOTER_CATEGORIES,
  ABOUT_US,
  SEARCH_LISTING,
  OFFER_PRODUCT_LIST,
  LOGOUT_ALL,
  COUPONS_OFFERS,
  COUPONS_OFFERS_V2,
  POPULAR_SUGGESTIONS,
  CHAT_API,
  USER_DETAILS,
  MEETING_TYPES,
  MEETING_CATEGORY,
  MEETING_IMAGES,
  REVERSE_GEOCODING,
  GEO_LOCATION_DETAILS,
  GOOGLE_MAP_SCRIPT,
  GOOGLE_MAP_PICKER_SCRIPT,
  STORES_LIST,
  STORES_LIST_BY_PINCODE,
  USER_ORDERS_DETAIALS,
  BRANDS_LIST,
  ONE_TAP,
  COUPON_LIST,
  COUPON_DESCRIPTION,
  COLLECT_COUPON,
  DECOLLECT_COUPON,
  PRODUCT_BULK,
  BREADCRUMBS,
  LOYALTY_INFO,
  DYNAMIC_FOOTER_LINKS,
  GAME_GET_OFFER,
  GAME_CLAIM_OFFER,
  EDD_FILTER_LIST,
  SLP_EDD_FILTER_LIST,
  SERVICEABILITY_CHECK,
  SEARCH_SUGGESTIONS_V1,
  AGGREGATED_FOOTER_DATA,
}

export const urls: { [key: string]: string } = {
  [ROUTES.PRODUCT]: '/app-api/index.php/products/details',
  [ROUTES.AUTH]: '/ReactConfig.php',
  [ROUTES.WISHLIST_IDS]: '/app-api/index.php/customer/get_wishlist_data',
  [ROUTES.RECO_WIDGETS]: '/gateway-api/rest/appapi/V2/getProductWidgets',
  [ROUTES.CHECK_DELIVERY]: '/custom/index/enterpincode',
  [ROUTES.SEARCH_SUGGESTIONS]: '/api/search/suggestions/v2',
  [ROUTES.TRENDING_SEARCHES]: '/search/trending',
  [ROUTES.GATEWAY]: '/gateway-api',
  [ROUTES.LIKE_REVIEW]: '/advancereview/index/like',
  [ROUTES.OFFERS]: '/gateway-api/offer/api/v1/product/{productId}/offer',
  [ROUTES.NAVIGATION]: '/getNavigation.php',
  [ROUTES.LOGOUT]: '/customer/account/logout/',
  [ROUTES.QNA]: '/custom/index/getqna',
  [ROUTES.NEWS_LETTER_SUBSCRIPTION]: '/newsletter/subscriber/customnew',
  [ROUTES.GET_VARIANTS]: '/gludo/listVariants',
  [ROUTES.GRAPH_API]: 'https://graph.facebook.com/me?fields=name,email',
  [ROUTES.FB_API]: '/app-api/index.php/user/sec_login_fb',
  [ROUTES.GOOGLE_API]: '/app-api/index.php/user/sec_login_google',
  [ROUTES.LOGIN]: '/customer/account/ajaxLogin/',
  [ROUTES.PRODUCT_LIST]: '/app-api/index.php/products/list',
  [ROUTES.DEVICE_TRACKING_SERVICE]: '/trk/device',
  [ROUTES.CATEGORY_PRICE_LIST]: '/app-api/index.php/categories/price_listing',
  [ROUTES.FOOTER_CATEGORIES]: '/gateway-api/api/v1/seo/footer_categories',
  [ROUTES.ABOUT_US]: '/gateway-api/api/v1/categories/dataForAboutSection',
  [ROUTES.SEARCH_LISTING]: '/api/search.list',
  [ROUTES.OFFER_PRODUCT_LIST]: '/app-api/index.php/products/list/offer',
  [ROUTES.LOGOUT_ALL]: '/app-api/index.php/customer/logout_from_all_session',
  [ROUTES.COUPONS_OFFERS]: '/gateway-api/offer/api/v1/product/customer/offer',
  [ROUTES.COUPONS_OFFERS_V2]:
    '/gateway-api/offer/api/v2/product/customer/offer',
  [ROUTES.POPULAR_SUGGESTIONS]: '/gateway-api/mynykaa/api/searchContent',
  [ROUTES.CHAT_API]: '/gateway-api/omsApis/getChatParams',
  [ROUTES.USER_DETAILS]: '/app-api/index.php/user/user_details',
  [ROUTES.MEETING_TYPES]: '/gateway-api/consult/v1/meeting_type',
  [ROUTES.MEETING_CATEGORY]: '/gateway-api/consult/v1/category',
  [ROUTES.MEETING_IMAGES]: '/gateway-api/consult/v1/image',
  [ROUTES.REVERSE_GEOCODING]: '/location/coords',
  [ROUTES.GEO_LOCATION_DETAILS]: '/get_geo_location_details',
  [ROUTES.GOOGLE_MAP_SCRIPT]: '/google/map',
  [ROUTES.GOOGLE_MAP_PICKER_SCRIPT]: '/google/map-picker',
  [ROUTES.STORES_LIST_BY_PINCODE]:
    '/app-api/index.php/store_api/v1/getStoresList',
  [ROUTES.STORES_LIST]: '/app-api/index.php/store_api/v1/getAllStores',
  [ROUTES.USER_ORDERS_DETAIALS]: '/user',
  [ROUTES.BRANDS_LIST]: '/retail-service/retail/store/brand/mapping/',
  [ROUTES.ONE_TAP]: '/googleconnect/index/connect',
  [ROUTES.COUPON_DESCRIPTION]: '/gateway-api/coupon/api/v2/coupon/description',
  [ROUTES.COLLECT_COUPON]: '/gateway-api/cartapi/v1/coupon/collect',
  [ROUTES.DECOLLECT_COUPON]: '/gateway-api/cartapi/v1/coupon/decollect',
  [ROUTES.PRODUCT_BULK]: '/app-api/index.php/products/details/bulk',
  [ROUTES.BREADCRUMBS]: '/api/v1/products/getBreadCrumb',
  [ROUTES.LOYALTY_INFO]: '/loyalty/customer/customer_tier_info',
  [ROUTES.DYNAMIC_FOOTER_LINKS]:
    '/gateway-api/api/v1/products/get_dynamic_footer_links',
  [ROUTES.GAME_GET_OFFER]: '/gateway-api/gamification/getOffer',
  [ROUTES.GAME_CLAIM_OFFER]: '/gateway-api/gamification/claimcoupon',
  [ROUTES.EDD_FILTER_LIST]: '/app-api/getedd/list',
  [ROUTES.SLP_EDD_FILTER_LIST]: '/app-api/aggregator/v1/edd.list',
  [ROUTES.SERVICEABILITY_CHECK]:
    '/darkstore/get_user_googlemaps_based_serviceability',
  [ROUTES.SEARCH_SUGGESTIONS_V1]: '/gludo/searchSuggestions',
  [ROUTES.AGGREGATED_FOOTER_DATA]: '/api/v1/seo/aggregated_footer_data',
};

export const getAPIHost = () =>
  __SERVER__ ? process.env.API_INTERNAL_HOST : process.env.API_HOST;

export const getUrl = (uri: ROUTES): string =>
  `${getAPIHost() || ''}${urls[uri]}`;

export const getGatewayUrl = () =>
  __SERVER__
    ? process.env.GATEWAY_API_INTERNAL
    : `${process.env.API_HOST || ''}/gateway-api`;

export const getUrlPrefixed = (
  requestPath: string,
  clientPrefix: string = '',
  serverPrefix: string = ''
) => {
  if (__SERVER__) {
    return `${serverPrefix}${requestPath}`;
  }
  return `${clientPrefix}${requestPath}`;
};

export const getDealsEndpoint = () =>
  __SERVER__ ? process.env.DEALS_INTERNAL_ENDPOINT : process.env.DEALS_ENDPOINT;

export const getSeoUrl = (uri: ROUTES): string => {
  const endpoint = getSEOEndpointUtil() || '';
  return `${endpoint}${urls[uri]}`;
};

export const getDealsUrl = () => `${getDealsEndpoint()}/inventory/data/json/`;

export const getEventsUrl = () => process.env.SP_EVENTS_URL || '';

export const getNykaaAPIHost = () => process.env.API_NYKAA || '';

export const getNykaaApiUrl = (uri: ROUTES): string =>
  `${getNykaaAPIHost() || ''}${urls[uri]}`;

export const getAbsoluteUrl = (url?: string): string => {
  const uri = url?.startsWith('/') ? url : `/${url}`;
  return `${process.env.API_HOST}${uri}`;
};
export const getNykaaApiInternalHost = () => 'https://api.nykaa.com';

export const getNykaaApiInternalUrl = (uri: ROUTES): string =>
  `${getNykaaApiInternalHost()}${urls[uri]}`;
